import { render, staticRenderFns } from "./EthicalPage.vue?vue&type=template&id=0a3db6c8"
import script from "./EthicalPage.vue?vue&type=script&lang=js"
export * from "./EthicalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports